import { sha256 } from '../../utils/utils';
import { AppUser } from './menu';

export async function fetchAppStoreVersion(url = '/d/version') {
  const response = await fetch(url);
  const parsedResponse = await response.text(); // this endpoint returns a ReadableStream, not JSON
  return parsedResponse;
}

/**
 *
 * @param TagManager react-gtm-module
 * @param gtmId
 * @param user
 */
export const setupGoogleTagManager = async (
  TagManager: any,
  gtmId: string,
  { id = '', name = '', isAdmin = false }: AppUser = {},
  haicVersion = 'Unknown version'
) => {
  const userIdHash = await sha256(id);
  const isH2OInternal = Boolean(name.toLowerCase().endsWith('@h2o.ai'));

  /* Provide metadata to Heap via window object */
  const w = window as any;
  w.HAIC = {};
  w.HAIC.user_id = userIdHash;
  w.HAIC.email = name;
  w.HAIC.is_admin = isAdmin;
  w.HAIC.heap_event_properties = {
    haic_version: haicVersion,
    is_h2o_internal_use: isH2OInternal,
  };
  w.HAIC.heap_user_properties = {
    is_h2o_internal_use: isH2OInternal,
  };

  /* Provide metadata to Google Analytics via dataLayer */
  TagManager.initialize({
    gtmId,
    dataLayer: {
      userId: userIdHash,
      is_h2o_internal_use: isH2OInternal,
      email: name,
      isAdmin,
    },
  });
};

export const setupGtm = async (tagManager: any, tagManagerId = '', user: AppUser = {}, haicVersion?: string) => {
  let isGtmReady = false;
  if (tagManagerId) {
    setupGoogleTagManager(tagManager, tagManagerId, user, haicVersion);
    isGtmReady = true;
  }

  return {
    isGtmReady,
    user,
  };
};
